import apiClient from '@/utils/request'
import { IRequestPayload, IGeneralResponse } from '@/api/types'
import {
  IIPListPayload,
  IIPListsResponse,
  IIPListResponse,
  IIPListAttributes,
  IIPListData,
  IIPBulkUpdateAttributes
} from '@/apps/traforama/interfaces/ipLists'

import { nestedQueryFormatter } from '@/utils/query'

export const fetchItems = async (
  payload: IIPListPayload
): Promise<IIPListsResponse> => {
  const params = Object.assign(
    { limit: payload.limit, start: payload.start },
    nestedQueryFormatter('filter', payload.filter || {})
  )
  const response = await apiClient.get<IIPListsResponse>('/ip_lists', {
    params
  })
  return response.data
}

export const fetchItem = async (id: string): Promise<IIPListResponse> => {
  const response = await apiClient.get<IIPListResponse>(`/ip_lists/${id}`)
  return response.data
}

export const createItem = async (
  payload: IIPListAttributes
): Promise<IIPListResponse> => {
  const response = await apiClient.post<IIPListResponse>('/ip_lists', payload)
  return response.data
}

export const updateItem = async (
  item: IIPListData
): Promise<IIPListResponse> => {
  const payload = { ...item }
  const response = await apiClient.put<IIPListResponse>(
    `/ip_lists/${item.id}`,
    payload
  )
  return response.data
}

export const bulkUpdate = async (
  item: IIPBulkUpdateAttributes
): Promise<IIPListResponse> => {
  const payload = { ...item }
  const response = await apiClient.put<IIPListResponse>(
    '/ip_lists/bulk_update',
    payload
  )
  return response.data
}

export const destroyItem = async (id: string): Promise<IIPListResponse> => {
  const response = await apiClient.delete<IIPListResponse>(`/ip_lists/${id}`)
  return response.data
}
